module.exports = __webpack_public_path__ + "img/team-work.7f3d1103.jpg";